
import React from "react";
import { Schemes, Utils } from "../../utils";
import { i18nManager } from "../../i18n";
import { Dropdown } from "@ronuse/noseur";
import * as ReactRouterDom from "react-router-dom";

function Footer() {
    const labels = i18nManager.Labels.footer;
    const { platform } = ReactRouterDom.useParams();

    return (<div className="footer">
        <div className="locations">
            {labels.locations.map((location, index) => (<div key={index}>
                {location.map((loc, sindex) => (<a key={sindex} style={(!platform && loc.location.includes("comm")) ? { display: "none" } : undefined} 
                href={Utils.createAbsoluteUrl((platform ? ("/" + platform) : ""), loc.location)}>{loc.label}</a>))}
            </div>))}
        </div>
        <div className="the-below">
            <span className="copyright">{labels.copyright}</span>
            <Dropdown borderless scheme={Schemes.RIVTN_HERA} options={i18nManager.Languages}
                selectedOptionIndex={Math.max(i18nManager.Languages.findIndex((value) => value.value === i18nManager.ActiveLanguage) ?? -1, 0)} onSelectOption={(option) => {
                    i18nManager.switchLanguage(option.value);
                    return true;
                }} />
            <div className="follow-social">
                <span>{labels.follow_us}</span>
                <span className="social">
                    {labels.socials.map((social) => (<a key={social.location} rel="noreferrer" target="_blank" href={social.location}><i className={social.icon} /></a>))}
                </span>
            </div>
        </div>
    </div>);
}

export default Footer;
